import { BreadcrumbRouteElement } from './breadcrumb-element';

export class BreadcrumbConfig {
  display: BreadcrumbRouteElement;
  routeElements?: BreadcrumbRouteElement[];

  constructor(
    display: BreadcrumbRouteElement,
    routeElements?: BreadcrumbRouteElement[]
  ) {
    this.display = display;
    this.routeElements = routeElements;
  }
}
